import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';
import { logConsole, logTransaction } from '../common/log';
import { handleThunkError } from '../common/util';
import { LogType } from '../models/log.model';
import { setIsLoadingCountState } from './appSlice';

interface ITemplateState {
  value: string;
}

const initialState: ITemplateState = {
  value: '',
};

/// THUNKS

export const fetchSomethingAsync = createAsyncThunk<{}, void>(
  'template/getSomethingAsync',
  async (e, { rejectWithValue, dispatch }) => {
    logTransaction(LogType.Info, '[template] getSomethingAsync');
    try {
      dispatch(setIsLoadingCountState(1));
      await setTimeout(() => { }, 1000);

      dispatch(setIsLoadingCountState(-1));
    } catch (err: any) {
      return handleThunkError(err, rejectWithValue, setIsLoadingCountState(-1));
    }
  }
);

/// SLICE

export const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    test: (state, action: PayloadAction<string>) => {
      logConsole(LogType.Info, '[template] test');
      state.value = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchSomethingAsync.fulfilled, (state, action) => {
      logConsole(LogType.Info, '[template] fetchSomethingAsync.fulfilled');
      state.value = '';
    });
  },
});

/// REDUCERS

export const { test } = templateSlice.actions;

/// CUSTOM SELECTORS
/*
** NOTE:
** To use this in a React component: selectTemplate(store.getState())
*/

export const selectTemplate = (state: RootState) => {
  return state.template.value + ' test';
};

export default templateSlice.reducer;
